"use client";

import React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function VisionaryLeadership() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="30021" id="exposing-the-system" className="relative h-screen min-h-[600px] w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605323/img/ny-parcel-map.png)] bg-cover bg-center bg-fixed bg-no-repeat opacity-5" />
        {}
        <div className="absolute inset-0 bg-transparent" />
      </div>

      {}
      <div className="absolute top-1/2 left-0 z-20 hidden -translate-y-1/2 flex-col lg:flex">
        <Button variant="default" size="icon" className="h-16 w-12 border-b border-white/10 bg-primary text-white hover:bg-primary/90" aria-label="Previous section">
          <ChevronUp className="h-6 w-6" />
        </Button>
        <Button variant="default" size="icon" className="h-16 w-12 bg-primary text-white hover:bg-primary/90" aria-label="Next section">
          <ChevronDown className="h-6 w-6" />
        </Button>
      </div>

      {}
      <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col justify-center px-4 pt-24 sm:px-6 lg:px-8">
        <div ref={ref} className={cn("flex max-w-3xl flex-col items-start text-left transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          <h1 className="before:mb-8 before:block before:h-1 before:w-[100px] before:bg-primary font-sans text-5xl font-bold leading-[1.1] tracking-tighter text-secondary sm:text-6xl md:text-7xl">
            Exposing the NY <br /> Property Tax Crisis
          </h1>

          <p className="mt-6 max-w-lg text-[20px] leading-relaxed text-secondary/80 sm:text-[20px]">
            Uncovering systemic inequities in New York&apos;s residential assessments through rigorous data-driven investigative journalism and public advocacy.
          </p>

          <div className="mt-8">
            <Button asChild size="lg" className="h-14 bg-secondary px-8 text-base font-bold uppercase tracking-wider text-white shadow-md transition-all hover:bg-secondary/95 hover:scale-105 active:scale-95">
              <Link to="#">View Reports</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}